import Navbar from "../components/Navbar";
import "./RegistroEnviado.css";


const MapaWeb = () => {
  return (
    <>
      <Navbar />

      <main className="main textos-legales">

        <h1>Mapa web</h1>
        
      </main>
    </>
  );
};

export default MapaWeb;